import React, { useState, useEffect } from "react";
import "./LegalQuestionnaire.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useNavigate } from "react-router-dom";
import base_url from "../api";

const prenupQuestions = [
    {
        section: "1. Your Details",
        questions: [
            { id: "your_name", label: "Your full legal name:", type: "text", required: true },
            { id: "your_email", label: "Your email address:", type: "email", required: true },
            { id: "your_phone", label: "Your telephone number:", type: "text", required: true },
            {
                id: "partner_name",
                label: "Your partner's full legal name:",
                type: "text",
                required: true,
            },
            {
                id: "both_over_18",
                label: "Are both parties aged 18 or over?",
                type: "radio",
                options: ["Yes", "No"],
                required: true,
            },
        ],
    },
    {
        section: "2. Marriage / Civil Partnership Details",
        questions: [
            {
                id: "relationship_type",
                label: "Type of relationship:",
                type: "radio",
                options: ["Marriage", "Civil Partnership"],
                required: true,
            },
            {
                id: "ceremony_date",
                label: "Proposed date of marriage / civil partnership:",
                type: "date",
                required: true,
            },
            {
                id: "first_marriage_you",
                label: "Is this a first marriage / civil partnership for you?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "first_marriage_partner",
                label:
                    "Is this a first marriage / civil partnership for your partner?",
                type: "radio",
                options: ["Yes", "No"],
            },
        ],
    },


    {
        section: "3. Timing & Voluntariness",
        questions: [
            {
                id: "weeks_before_ceremony",
                label: "How many weeks remain before the ceremony?",
                type: "number",
            },
            {
                id: "pressure",
                label:
                    "Has either party applied pressure or imposed a deadline to sign a pre‑nuptial agreement?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "drafts_prepared",
                label:
                    "Have any draft agreements already been prepared or discussed?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "voluntary",
                label:
                    "Do both parties intend to enter into the agreement voluntarily?",
                type: "radio",
                options: ["Yes", "No"],
            },
        ],
    },


    {
        section: "4. Independent Legal Advice",
        questions: [
            {
                id: "partner_aware_solicitor",
                label:
                    "Is your partner aware they must instruct their own solicitor?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "partner_instructed",
                label: "Has your partner already instructed a solicitor?",
                type: "radio",
                options: ["Yes", "No", "Not yet"],
            },
        ],
    },

    {
        section: "5. Financial Disclosure",
        questions: [
            {
                id: "full_disclosure",
                label:
                    "Are you willing and able to provide full financial disclosure?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "assets",
                label: "Please indicate which assets or interests apply to you (tick all that apply):",
                type: "checkbox",
                options: [
                    "Property (UK)",
                    "Property (Overseas)",
                    "Business interests / shares",
                    "Trust interests",
                    "Pensions",
                    "Investments / savings",
                    "Inheritances (received or anticipated)",
                    "Significant liabilities or debts",
                ],
            },
            {
                id: "joint_assets",
                label:
                    "Are any assets held jointly or through corporate or trust structures?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "international_assets",
                label:
                    "Are there any international assets or cross‑border issues?",
                type: "radio",
                options: ["Yes", "No"],
            },
        ],
    },


    {
        section: "6. Children & Future Planning",
        questions: [
            {
                id: "children_you",
                label:
                    "Do you have children from a previous relationship?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "children_partner",
                label:
                    "Does your partner have children from a previous relationship?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "future_children",
                label:
                    "Do you intend to have children together?",
                type: "radio",
                options: ["Yes", "No", "Unsure"],
            },
        ],
    },

    {
        section: "7. Residency & Jurisdiction",
        questions: [
            {
                id: "domiciled_you",
                label:
                    "Are you domiciled or habitually resident in England & Wales?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "domiciled_partner",
                label:
                    "Is your partner domiciled or habitually resident in England & Wales?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "other_jurisdictions",
                label:
                    "Are there connections to any other jurisdictions (e.g. nationality, residence, assets)?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "jurisdiction_details",
                label: "If yes, please provide details:",
                type: "textarea",
            },
        ],
    },

    {
        section: "8. Objectives & Expectations",
        questions: [
            {
                id: "reasons",
                label:
                    "What are your main reasons for seeking a pre‑nuptial agreement?",
                type: "textarea",
            },
            {
                id: "protect_assets",
                label:
                    "Are there specific assets you wish to protect or ring‑fence?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "protected_assets_details",
                label: "If yes, please describe:",
                type: "textarea",
            },
            {
                id: "review_expectation",
                label:
                    "Would you expect the agreement to be reviewed after marriage or on certain events (e.g. children, length of marriage)?",
                type: "radio",
                options: ["Yes", "No"],
            },
        ],
    },


    {
        section: "9. Understanding & Acknowledgements",
        questions: [
            {
                id: "understanding_binding",
                label:
                    "I understand that a pre‑nuptial agreement is not automatically legally binding but may be upheld by the court if properly prepared.",
                type: "checkbox",
                options: ["I understand"],
            },
            {
                id: "understanding_fairness",
                label:
                    "I understand the importance of fairness, full disclosure, independent legal advice, and sufficient time before the ceremony.",
                type: "checkbox",
                options: ["I understand"],
            },
            {
                id: "accuracy_confirm",
                label:
                    "I confirm that the information provided is accurate to the best of my knowledge.",
                type: "checkbox",
                options: ["I confirm"],
                required: true,
            },
        ],
    },

    {
        section: "10. Practical Information",
        questions: [
            {
                id: "wedding_deposits",
                label:
                    "Have wedding or venue deposits already been paid?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "urgency",
                label:
                    "Are there any urgency or timing concerns we should be aware of?",
                type: "textarea",
            },
            {
                id: "referral_source",
                label: "How did you hear about our firm?",
                type: "text",
            },
            {
                id: "data_consent",
                label:
                    "Data Protection & Consent - I consent to the firm processing my personal data for the purpose of assessing my enquiry, in accordance with the UK GDPR and the firm's Privacy Policy.",
                type: "checkbox",
                options: ["I consent"],
            },
        ],
    },
];
const willQuestions = [
    {
        section: "A. Personal Details & Capacity",
        questions: [
            {
                id: "full_name",
                label: "What is your full legal name?",
                type: "text",
                required: true,
            },
            {
                id: "over_18",
                label: "Are you aged 18 or over?",
                type: "radio",
                options: ["Yes", "No"],
                required: true,
            },
            {
                id: "mental_capacity",
                label:
                    "Do you consider yourself to have full mental capacity to make a Will?",
                type: "radio",
                options: ["Yes", "No"],
                required: true,
            },
            {
                id: "enquiry_for",
                label:
                    "Are you making this enquiry for yourself or on behalf of someone else?",
                type: "radio",
                options: ["For myself", "On behalf of someone else"],
                required: true,
            },
            {
                id: "relationship_to_other",
                label:
                    "If on behalf of someone else, what is your relationship to them?",
                type: "text",
            },
        ],
    },


    {
        section: "B. Marital / Relationship Status",
        questions: [
            {
                id: "marital_status",
                label: "What is your current marital status?",
                type: "radio",
                options: [
                    "Single",
                    "Married",
                    "Civil Partnership",
                    "Divorced",
                    "Separated",
                    "Widowed",
                ],
                required: true,
            },
            {
                id: "marriage_date",
                label:
                    "If married or in a civil partnership, when did this take place?",
                type: "date",
            },
            {
                id: "currently_separated",
                label:
                    "Are you currently separated or in the process of divorce?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "planning_marriage",
                label:
                    "Are you planning to marry or enter a civil partnership in the near future? (Please note: marriage/civil partnership revokes an existing Will unless made in contemplation of marriage.)",
                type: "radio",
                options: ["Yes", "No"],
            },
        ],
    },

    {
        section: "C. Existing Wills",
        questions: [
            {
                id: "existing_will",
                label: "Do you currently have a Will?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "will_date",
                label: "If yes: When was it made?",
                type: "date",
            },
            {
                id: "will_jurisdiction",
                label: "Was it made in England & Wales?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "replace_will",
                label:
                    "Do you wish to replace or update an existing Will?",
                type: "radio",
                options: ["Yes", "No"],
            },
        ],
    },


    {
        section: "D. Children & Dependants",
        questions: [
            {
                id: "has_children",
                label: "Do you have any children?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "number_of_children",
                label: "If yes: How many?",
                type: "number",
            },
            {
                id: "children_under_18",
                label: "Are any under 18?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "dependants",
                label:
                    "Do you have any stepchildren or financially dependent individuals?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "excluded_people",
                label:
                    "Are there any individuals who may reasonably expect to benefit from your estate but whom you do not intend to provide for?",
                type: "radio",
                options: ["Yes", "No"],
            },
        ],
    },


    {
        section: "E. Assets & Estate Overview",
        questions: [
            {
                id: "assets_owned",
                label: "Please indicate which of the following you own (tick all that apply):",
                type: "checkbox",
                options: [
                    "Property (UK)",
                    "Property (Overseas)",
                    "Bank accounts / savings",
                    "Investments / ISAs",
                    "Pensions",
                    "Business interests",
                    "Trust interests",
                    "Valuable personal items (jewellery, art, vehicles)",
                ],
            },
            {
                id: "joint_assets",
                label:
                    "Are any assets owned jointly with another person?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "assets_outside_ew",
                label:
                    "Do you have assets outside England & Wales?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "significant_debts",
                label:
                    "Do you have significant debts or liabilities?",
                type: "radio",
                options: ["Yes", "No"],
            },
        ],
    },


    {
        section: "F. Beneficiaries & Distribution",
        questions: [
            {
                id: "beneficiaries",
                label:
                    "Who would you like to benefit from your estate?",
                type: "textarea",
            },
            {
                id: "specific_gifts",
                label:
                    "Do you wish to leave specific gifts (cash, property, personal items)?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "exclude_beneficiaries",
                label:
                    "Do you intend to exclude anyone who might expect to benefit?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "charity_gifts",
                label:
                    "Are you considering leaving gifts to charity?",
                type: "radio",
                options: ["Yes", "No"],
            },
        ],
    },

    {
        section: "G. Executors & Guardians",
        questions: [
            {
                id: "chosen_executors",
                label:
                    "Have you chosen executors for your Will?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "executors_details",
                label: "If yes, who?",
                type: "textarea",
            },
            {
                id: "guardians",
                label:
                    "If you have children under 18, have you considered appointing guardians?",
                type: "radio",
                options: ["Yes", "No"],
            },
        ],
    },


    {
        section: "H. Tax & Planning Considerations",
        questions: [
            {
                id: "inheritance_tax",
                label:
                    "Do you believe your estate may be subject to Inheritance Tax?",
                type: "radio",
                options: ["Yes", "No", "Unsure"],
            },
            {
                id: "previous_tax_advice",
                label:
                    "Have you received any previous estate or tax planning advice?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "planning_interests",
                label: "Are you interested in advice on:",
                type: "checkbox",
                options: [
                    "Inheritance Tax planning",
                    "Trusts",
                    "Asset protection",
                    "Business succession",
                ],
            },
        ],
    },

    {
        section: "I. Complexity & Special Circumstances",
        questions: [
            {
                id: "family_disputes",
                label:
                    "Are there any family disputes, blended families, or sensitive circumstances we should be aware of?",
                type: "textarea",
            },
            {
                id: "urgency_or_health",
                label:
                    "Are there any health issues or urgency concerns affecting timing?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "urgent_services",
                label:
                    "Do you require home, hospital, or urgent Will services?",
                type: "radio",
                options: ["Yes", "No"],
            },
        ],
    },

    {
        section: "J. Practical & Compliance",
        questions: [
            {
                id: "domiciled_ew",
                label:
                    "Are you domiciled in England & Wales?",
                type: "radio",
                options: ["Yes", "No"],
                required: true,
            },
            {
                id: "other_jurisdictions",
                label:
                    "Is there any connection to another jurisdiction?",
                type: "radio",
                options: ["Yes", "No"],
            },
            {
                id: "referral_source",
                label:
                    "How did you hear about our firm?",
                type: "text",
            },
        ],
    },
];

// Required fields for each questionnaire type
const REQUIRED_FIELDS = {
    divorce: [
        "full_name",
        "email",
        "dob",
        "phone",
        "address",
        "same_address",
        "preferred_contact",
        "relationship_type",
        "marriage_date",
        "divorce_decision",
        "children",
        "client_declaration",
    ],
    prenup: [
        "your_name",
        "your_email",
        "your_phone",
        "partner_name",
        "both_over_18",
        "relationship_type",
        "ceremony_date",
        "accuracy_confirm",
    ],
    will: [
        "full_name",
        "over_18",
        "mental_capacity",
        "enquiry_for",
        "marital_status",
        "domiciled_ew",
    ],
};

const QUESTION_SETS = {
    divorce: [
        {
            section: "Section 1: Personal Details",
            questions: [
                { id: "full_name", label: "Full Name", type: "text", required: true },
                { id: "dob", label: "Date of Birth", type: "date", required: true },
                { id: "email", label: "Email Address", type: "email", required: true },
                { id: "phone", label: "Phone Number", type: "text", required: true },
                { id: "address", label: "Current Address", type: "textarea", required: true },
                {
                    id: "same_address",
                    label: "Are you currently living at the same address as your spouse?",
                    type: "radio",
                    options: ["Yes", "No"],
                    required: true,
                },
                {
                    id: "preferred_contact",
                    label: "Preferred method of contact:",
                    type: "radio",
                    options: ["Email", "Phone", "Either"],
                    required: true,
                },
            ],
        },
        {
            section: "Section 2: Spouse / Partner Details",
            questions: [
                { id: "spouse_name", label: "Spouse / Partner Full Name", type: "text" },
                { id: "spouse_dob", label: "Date of Birth (if known)", type: "date" },
                { id: "spouse_address", label: "Current Address (if different from yours)", type: "textarea" },
                {
                    id: "living_together",
                    label: "Are you still living together?",
                    type: "radio",
                    options: ["Yes", "No"],
                },
            ],
        },
        {
            section: "Section 3: Relationship & Marriage Details",
            questions: [
                {
                    id: "relationship_type",
                    label: "Type of relationship:",
                    type: "radio",
                    options: ["Marriage", "Civil Partnership"],
                    required: true,
                },
                { id: "marriage_date", label: "Date of marriage / civil partnership", type: "date", required: true },
                { id: "marriage_place", label: "Place of marriage", type: "text" },
                { id: "relationship_length", label: "Length of relationship prior to marriage (approx.)", type: "text" },
                {
                    id: "proceedings_started",
                    label: "Have divorce or separation proceedings already started?",
                    type: "radio",
                    options: ["Yes", "No"],
                },
                {
                    id: "proceedings_details",
                    label: "If yes, please provide details (court, dates, documents issued):",
                    type: "textarea",
                },
            ],
        },
        {
            section: "Section 4: Reason for Divorce",
            questions: [
                {
                    id: "divorce_decision",
                    label: "Have you already decided to proceed with divorce?",
                    type: "radio",
                    options: ["Yes", "Not sure"],
                    required: true,
                },
                {
                    id: "divorce_reason",
                    label: "Main reason for separation (select all that apply):",
                    type: "checkbox",
                    options: [
                        "Irretrievable breakdown",
                        "Infidelity",
                        "Unreasonable behaviour",
                        "Separation",
                        "Other",
                    ],
                },
                { id: "divorce_reason_other", label: "Other (please specify)", type: "text" },
                {
                    id: "abuse",
                    label: "Are there any allegations of domestic abuse, coercive control, or safeguarding concerns?",
                    type: "radio",
                    options: ["Yes", "No"],
                },
                {
                    id: "abuse_details",
                    label: "If yes, please briefly explain (optional):",
                    type: "textarea",
                },
            ],
        },
        {
            section: "Section 5: Children",
            questions: [
                {
                    id: "children",
                    label: "Do you have children together?",
                    type: "radio",
                    options: ["Yes", "No"],
                    required: true,
                },
                { id: "child_name", label: "Child's name", type: "text" },
                { id: "child_dob", label: "Date of birth", type: "date" },
                { id: "child_arrangements", label: "Current living arrangements", type: "textarea" },
                {
                    id: "child_disputes",
                    label: "Are there any disagreements about:",
                    type: "checkbox",
                    options: [
                        "Living arrangements",
                        "Contact / visitation",
                        "Schooling",
                        "Medical decisions",
                    ],
                },
                {
                    id: "child_safeguarding",
                    label: "Are there any safeguarding concerns relating to the children?",
                    type: "radio",
                    options: ["Yes", "No"],
                },
            ],
        },
        {
            section: "Section 6: Financial Information",
            questions: [
                {
                    id: "property_ownership",
                    label: "Do you jointly own or rent a property?",
                    type: "radio",
                    options: ["Own", "Rent", "Neither"],
                },
                { id: "home_value", label: "Approximate value of family home (if known):", type: "text" },
                { id: "mortgage_outstanding", label: "Mortgage outstanding (if applicable):", type: "text" },
                {
                    id: "additional_property",
                    label: "Do either of you own additional property?",
                    type: "radio",
                    options: ["Yes", "No"],
                },
                {
                    id: "joint_accounts",
                    label: "Do you have joint bank accounts?",
                    type: "radio",
                    options: ["Yes", "No"],
                },
                {
                    id: "financial_assets",
                    label: "Do either of you have:",
                    type: "checkbox",
                    options: [
                        "Savings",
                        "Investments",
                        "Pensions",
                        "Business interests",
                    ],
                },
                {
                    id: "financial_advice",
                    label: "Are you seeking advice on:",
                    type: "checkbox",
                    options: [
                        "Financial settlement",
                        "Spousal maintenance",
                        "Pension sharing",
                    ],
                },
            ],
        },
        {
            section: "Section 7: Employment & Income",
            questions: [
                {
                    id: "employment_status",
                    label: "Your employment status:",
                    type: "radio",
                    options: ["Employed", "Self-employed", "Unemployed"],
                },
                { id: "annual_income", label: "Approximate annual income:", type: "text" },
                {
                    id: "spouse_employment",
                    label: "Spouse/partner's employment status (if known):",
                    type: "radio",
                    options: ["Employed", "Self-employed", "Unemployed", "Not known"],
                },
                { id: "spouse_income", label: "Approximate annual income (if known):", type: "text" },
            ],
        },
        {
            section: "Section 8: Legal History",
            questions: [
                {
                    id: "previous_solicitor",
                    label: "Have you previously instructed a solicitor regarding this matter?",
                    type: "radio",
                    options: ["Yes", "No"],
                },
                {
                    id: "court_orders",
                    label: "Are there any existing court orders in place?",
                    type: "radio",
                    options: ["Yes", "No"],
                },
                { id: "court_orders_details", label: "If yes, please specify:", type: "textarea" },
            ],
        },
        {
            section: "Section 9: Objectives & Priorities",
            questions: [
                {
                    id: "main_concerns",
                    label: "What are your main concerns at this stage? (e.g. children, finances, speed, privacy)",
                    type: "textarea",
                },
                {
                    id: "desired_outcome",
                    label: "What outcome are you hoping to achieve?",
                    type: "textarea",
                },
                {
                    id: "resolution_options",
                    label: "Are you open to:",
                    type: "checkbox",
                    options: [
                        "Mediation",
                        "Negotiated settlement",
                        "Court proceedings if required",
                    ],
                },
            ],
        },
        {
            section: "Section 10: Urgency & Next Steps",
            questions: [
                {
                    id: "urgent_issue",
                    label: "Is there an urgent issue requiring immediate advice?",
                    type: "radio",
                    options: ["Yes", "No"],
                },
                { id: "urgent_details", label: "If yes, please explain:", type: "textarea" },
                {
                    id: "resolution_timeline",
                    label: "When would you like your matter resolved (if possible)?",
                    type: "text",
                },
            ],
        },
        {
            section: "Section 11: Final Declarations",
            questions: [
                {
                    id: "referral_source",
                    label: "How did you hear about Sandy Randhawa Solicitors?",
                    type: "radio",
                    options: ["Google", "Referral", "Website", "Other"],
                },
                {
                    id: "additional_info",
                    label: "Any additional information you would like us to know before the consultation?",
                    type: "textarea",
                },
                {
                    id: "client_declaration",
                    label: "Client Declaration - I confirm that the information provided is accurate to the best of my knowledge.",
                    type: "checkbox",
                    options: ["I confirm"],
                    required: true,
                },
                {
                    id: "referral_consent_question",
                    label: "Referral & Data Sharing Consent - If I am unable to act for you, do you consent to your matter being referred to another suitably qualified, credible, and regulated solicitor?",
                    type: "radio",
                    options: ["Yes, I consent to a referral", "No, I do not consent to a referral"],
                },
            ],
        },
    ],

    prenup: prenupQuestions,


    will: willQuestions,
};
/* ---------------- TAB HEADINGS ---------------- */

const TAB_CONTENT = {
  divorce: {
    title: "Divorce & Family Law – Pre-Consultation Questionnaire",
    subtitle:
      "All information provided is confidential and helps us prepare for your initial consultation.",
  },
  prenup: {
    title: "Pre-Nuptial Agreement – Client Intake Form",
    subtitle:
      "This form helps us assess whether we are able to advise you on a pre-nuptial agreement. Completing this form does not create a solicitor–client relationship. Formal instructions will only be accepted following a conflict check and written confirmation.",
  },
  will: {
    title: "Pre-Screening Questions – Will Instructions (England & Wales)",
    subtitle:
      "This pre-screening questionnaire helps us understand your circumstances before providing advice on preparing a will.",
  },
};


const TABS = [
  { key: "divorce", label: "Divorce" },
  { key: "prenup", label: "Prenuptial Agreement" },
  { key: "will", label: "Create a Will" },
];




const LegalQuestionnaire = () => {
  const [activeTab, setActiveTab] = useState("divorce");
  const [currentStep, setCurrentStep] = useState(0); // Track current step/section
  const navigate = useNavigate();

  // Answers stored per tab
  const [answers, setAnswers] = useState({
    divorce: {},
    prenup: {},
    will: {},
  });

  // Questionnaire status
  const [questionnaireStatus, setQuestionnaireStatus] = useState({
    divorce: { referenceNumber: null, isCompleted: false },
    prenup: { referenceNumber: null, isCompleted: false },
    will: { referenceNumber: null, isCompleted: false },
  });

  // Loading and error states
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [completing, setCompleting] = useState(false);
  const [saveMessage, setSaveMessage] = useState({ type: "", text: "" });
  const [loadedTabs, setLoadedTabs] = useState(new Set());
  const [fieldErrors, setFieldErrors] = useState(new Set()); // Track fields with errors
  const [profileComplete, setProfileComplete] = useState(null); // null = checking, true/false = result
  const [checkingProfile, setCheckingProfile] = useState(true);

  /* ---------------- CHECK PROFILE COMPLETION ---------------- */

  useEffect(() => {
    const checkProfileCompletion = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/login");
          return;
        }

        setCheckingProfile(true);
        const response = await fetch(`${base_url}/profile-complete`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();

        if (response.ok && data.success) {
          setProfileComplete(data.isComplete);
        } else {
          setProfileComplete(false);
        }
      } catch (error) {
        console.error("Error checking profile completion:", error);
        setProfileComplete(false);
      } finally {
        setCheckingProfile(false);
      }
    };

    checkProfileCompletion();
  }, [navigate]);

  /* ---------------- LOAD SAVED ANSWERS ---------------- */

  const loadSavedAnswers = async (questionnaireType) => {
    // Skip if already loaded
    if (loadedTabs.has(questionnaireType)) {
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      setLoading(true);
      const response = await fetch(
        `${base_url}/questionnaire/${questionnaireType}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (response.ok && data.success) {
        if (data.answers) {
          setAnswers((prev) => ({
            ...prev,
            [questionnaireType]: data.answers,
          }));
        }
        if (data.referenceNumber !== undefined || data.isCompleted !== undefined) {
          setQuestionnaireStatus((prev) => ({
            ...prev,
            [questionnaireType]: {
              referenceNumber: data.referenceNumber || null,
              isCompleted: data.isCompleted || false,
            },
          }));
        }
        setLoadedTabs((prev) => new Set(prev).add(questionnaireType));
      }
    } catch (error) {
      console.error("Error loading saved answers:", error);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- EFFECTS ---------------- */

  // Load answers when component mounts and when tab changes
  useEffect(() => {
    if (!loadedTabs.has(activeTab)) {
      loadSavedAnswers(activeTab);
    }
    // Clear field errors and reset step when switching tabs
    setFieldErrors(new Set());
    setCurrentStep(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  /* ---------------- HANDLERS ---------------- */

  const handleChange = (id, value) => {
    setAnswers((prev) => ({
      ...prev,
      [activeTab]: {
        ...prev[activeTab],
        [id]: value,
      },
    }));
    // Clear save message when user makes changes
    if (saveMessage.text) {
      setSaveMessage({ type: "", text: "" });
    }
    // Remove field from errors if it's been filled
    if (fieldErrors.has(id)) {
      setFieldErrors((prev) => {
        const newErrors = new Set(prev);
        newErrors.delete(id);
        return newErrors;
      });
    }
  };

  const handleCheckboxChange = (id, option) => {
    const current = answers[activeTab][id] || [];
    const updated = current.includes(option)
      ? current.filter((o) => o !== option)
      : [...current, option];

    setAnswers((prev) => ({
      ...prev,
      [activeTab]: {
        ...prev[activeTab],
        [id]: updated,
      },
    }));
    
    // Clear save message when user makes changes
    if (saveMessage.text) {
      setSaveMessage({ type: "", text: "" });
    }
    
    // Remove field from errors if it's been filled (at least one option selected)
    if (updated.length > 0 && fieldErrors.has(id)) {
      setFieldErrors((prev) => {
        const newErrors = new Set(prev);
        newErrors.delete(id);
        return newErrors;
      });
    }
  };

  /* ---------------- VALIDATION ---------------- */

  // Validate current step only
  const validateCurrentStep = () => {
    const currentAnswers = answers[activeTab] || {};
    const errorFields = new Set();
    const allSections = QUESTION_SETS[activeTab] || [];
    
    if (currentStep >= allSections.length) return true;
    
    const currentSection = allSections[currentStep];
    
    // Validate all questions in current step
    currentSection.questions.forEach((q) => {
      const value = currentAnswers[q.id];
      
      // Check if field is empty or invalid (all fields are required)
      const isEmpty = 
        value === undefined ||
        value === null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0);
      
      if (isEmpty) {
        errorFields.add(q.id);
      }
      
      // Additional email validation
      if ((q.type === "email" || q.id === "email" || q.id === "your_email") && value && value !== "") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          errorFields.add(q.id);
        }
      }
    });

    // Update field errors state
    setFieldErrors(errorFields);
    
    return errorFields.size === 0;
  };

  const validateAnswers = () => {
    const currentAnswers = answers[activeTab] || {};
    const errors = [];
    const errorFields = new Set();

    // Get all questions for current tab
    const allQuestions = QUESTION_SETS[activeTab] || [];
    const questionMap = {};
    
    // Check ALL questions - all are required
    allQuestions.forEach((section) => {
      section.questions.forEach((q) => {
        questionMap[q.id] = q.label;
        const value = currentAnswers[q.id];
        
        // Check if field is empty or invalid (all fields are required)
        const isEmpty = 
          value === undefined ||
          value === null ||
          value === "" ||
          (Array.isArray(value) && value.length === 0);
        
        if (isEmpty) {
          errorFields.add(q.id);
          errors.push(`${q.label} is required`);
        }
        
        // Additional email validation
        if ((q.type === "email" || q.id === "email" || q.id === "your_email") && value && value !== "") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(value)) {
            errorFields.add(q.id);
            errors.push(`Please enter a valid email address for ${q.label}`);
          }
        }
      });
    });

    // Update field errors state
    setFieldErrors(errorFields);
    
    return errors;
  };

  // Check if a section is completed
  const isSectionCompleted = (sectionIndex) => {
    const sections = QUESTION_SETS[activeTab] || [];
    if (sectionIndex >= sections.length) return false;
    
    const section = sections[sectionIndex];
    const currentAnswers = answers[activeTab] || {};
    
    return section.questions.every((q) => {
      const value = currentAnswers[q.id];
      return value !== undefined && value !== null && value !== "" && 
             !(Array.isArray(value) && value.length === 0);
    });
  };

  // Save progress without validation (for "Save & Continue Later")
  const handleSaveProgress = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      setSaving(true);
      setSaveMessage({ type: "", text: "" });

      const response = await fetch(`${base_url}/questionnaire/save`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          questionnaireType: activeTab,
          answers: answers[activeTab],
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setSaveMessage({
          type: "success",
          text: "Progress saved successfully! You can continue later.",
        });
        setLoadedTabs((prev) => new Set(prev).add(activeTab));
        setTimeout(() => {
          setSaveMessage({ type: "", text: "" });
        }, 3000);
      } else {
        throw new Error(data.message || "Failed to save progress");
      }
    } catch (error) {
      console.error("Error saving progress:", error);
      setSaveMessage({
        type: "error",
        text: error.message || "Failed to save progress. Please try again.",
      });
    } finally {
      setSaving(false);
    }
  };

  // Complete questionnaire with full validation
  const handleSave = async (isComplete = false) => {
    // Only validate if completing, not for saving progress
    if (isComplete) {
      const validationErrors = validateAnswers();
      
      if (validationErrors.length > 0) {
        setSaveMessage({
          type: "error",
          text: `Please complete all required fields before submitting:\n\n${validationErrors.map((err, idx) => `${idx + 1}. ${err}`).join("\n")}`,
        });
        // Scroll to top to show error message
        window.scrollTo({ top: 0, behavior: "smooth" });
        // Scroll to first error field
        if (fieldErrors.size > 0) {
          const firstErrorId = Array.from(fieldErrors)[0];
          setTimeout(() => {
            const errorElement = document.querySelector(`[name="${firstErrorId}"], input[id="${firstErrorId}"], textarea[id="${firstErrorId}"]`);
            if (errorElement) {
              errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
              errorElement.focus();
            }
          }, 500);
        }
        return;
      }
      
      // Clear field errors if validation passes
      setFieldErrors(new Set());
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      if (isComplete) {
        setCompleting(true);
      } else {
        setSaving(true);
      }
      setSaveMessage({ type: "", text: "" });

      const endpoint = isComplete ? "/questionnaire/complete" : "/questionnaire/save";
      const sections = QUESTION_SETS[activeTab] || [];

      const requestBody = {
        questionnaireType: activeTab,
        answers: answers[activeTab],
      };

      // Only include sections for completion (PDF generation)
      if (isComplete) {
        requestBody.sections = sections;
      }

      const response = await fetch(`${base_url}${endpoint}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        if (isComplete && data.referenceNumber) {
          setQuestionnaireStatus((prev) => ({
            ...prev,
            [activeTab]: {
              referenceNumber: data.referenceNumber,
              isCompleted: true,
            },
          }));
          setSaveMessage({
            type: "success",
            text: `Questionnaire completed successfully!\n\nYour Reference Number: ${data.referenceNumber}\n\nA confirmation email with your PDF has been sent to your email address.`,
          });
        } else if (data.wasCompleted) {
          // If they were editing a completed questionnaire, reset the status
          setQuestionnaireStatus((prev) => ({
            ...prev,
            [activeTab]: {
              referenceNumber: prev[activeTab]?.referenceNumber || null,
              isCompleted: false,
            },
          }));
          setSaveMessage({
            type: "success",
            text: "Progress saved successfully! The questionnaire has been marked as in-progress since you're making changes.",
          });
        } else {
          setSaveMessage({
            type: "success",
            text: "Progress saved successfully! You can continue later.",
          });
        }
        // Mark this tab as loaded so we don't reload unnecessarily
        setLoadedTabs((prev) => new Set(prev).add(activeTab));
        // Clear message after 5 seconds for completion, 3 for save
        setTimeout(() => {
          setSaveMessage({ type: "", text: "" });
        }, isComplete ? 10000 : 3000);
      } else {
        throw new Error(data.message || `Failed to ${isComplete ? 'complete' : 'save'} questionnaire`);
      }
    } catch (error) {
      console.error(`Error ${isComplete ? 'completing' : 'saving'} questionnaire:`, error);
      setSaveMessage({
        type: "error",
        text: error.message || `Failed to ${isComplete ? 'complete' : 'save'} questionnaire. Please try again.`,
      });
    } finally {
      if (isComplete) {
        setCompleting(false);
      } else {
        setSaving(false);
      }
    }
  };

  /* ---------------- INPUT RENDERER ---------------- */

  const renderInput = (q) => {
    const value = answers[activeTab][q.id] || "";
    const isRequired = true; // All questions are now required
    const hasError = fieldErrors.has(q.id); // Check if this field has an error

    switch (q.type) {
      case "text":
      case "email":
      case "date":
      case "number":
        return (
          <div>
            <input
              type={q.type}
              id={q.id}
              name={q.id}
              value={value}
              placeholder={isRequired ? "Your answer... (required)" : "Your answer..."}
              onChange={(e) => handleChange(q.id, e.target.value)}
              className={hasError ? "error-input" : ""}
              style={hasError ? { borderColor: "#dc2626", backgroundColor: "#fef2f2" } : {}}
            />
            {hasError && (
              <span style={{ fontSize: "12px", color: "#dc2626", marginTop: "4px", display: "block" }}>
                This field is required
              </span>
            )}
          </div>
        );

      case "textarea":
        return (
          <div>
            <textarea
              id={q.id}
              name={q.id}
              value={value}
              placeholder={isRequired ? "Your answer... (required)" : "Your answer..."}
              onChange={(e) => handleChange(q.id, e.target.value)}
              className={hasError ? "error-input" : ""}
              style={hasError ? { borderColor: "#dc2626", backgroundColor: "#fef2f2" } : {}}
            />
            {hasError && (
              <span style={{ fontSize: "12px", color: "#dc2626", marginTop: "4px", display: "block" }}>
                This field is required
              </span>
            )}
          </div>
        );

      case "radio":
        return (
          <div>
            <div className="radio-group" style={hasError ? { border: "2px solid #dc2626", padding: "10px", borderRadius: "8px", backgroundColor: "#fef2f2" } : {}}>
              {q.options.map((opt) => (
                <label key={opt}>
                  <input
                    type="radio"
                    name={q.id}
                    id={`${q.id}-${opt}`}
                    checked={value === opt}
                    onChange={() => handleChange(q.id, opt)}
                  />
                  {opt}
                </label>
              ))}
            </div>
            {hasError && (
              <span style={{ fontSize: "12px", color: "#dc2626", marginTop: "4px", display: "block" }}>
                Please select an option
              </span>
            )}
          </div>
        );

      case "checkbox":
        return (
          <div>
            <div className="checkbox-group" style={hasError ? { border: "2px solid #dc2626", padding: "10px", borderRadius: "8px", backgroundColor: "#fef2f2" } : {}}>
              {q.options.map((opt) => (
                <label key={opt}>
                  <input
                    type="checkbox"
                    id={`${q.id}-${opt}`}
                    checked={(value || []).includes(opt)}
                    onChange={() => handleCheckboxChange(q.id, opt)}
                  />
                  {opt}
                </label>
              ))}
            </div>
            {hasError && (
              <span style={{ fontSize: "12px", color: "#dc2626", marginTop: "4px", display: "block" }}>
                Please select at least one option
              </span>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  /* ---------------- RENDER ---------------- */

  const sections = QUESTION_SETS[activeTab] || [];
  const isCompleted = questionnaireStatus[activeTab]?.isCompleted || false;
  const referenceNumber = questionnaireStatus[activeTab]?.referenceNumber;

  // Show profile completion message if profile is not complete
  if (checkingProfile) {
    return (
      <div className="legal-wrapper">
        <div style={{ textAlign: "center", padding: "60px 20px" }}>
          <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "32px", color: "#3b82f6", marginBottom: "16px" }}></i>
          <p style={{ fontSize: "16px", color: "#64748b" }}>Checking profile...</p>
        </div>
      </div>
    );
  }

  if (profileComplete === false) {
    return (
      <div className="legal-wrapper">
        <div style={{
          padding: "40px",
          textAlign: "center",
          background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
          borderRadius: "12px",
          border: "2px solid #f59e0b",
          marginBottom: "20px"
        }}>
          <i className="fa-solid fa-exclamation-triangle" style={{ fontSize: "48px", color: "#d97706", marginBottom: "20px" }}></i>
          <h2 style={{ color: "#92400e", marginBottom: "16px", fontSize: "24px" }}>Please Complete Your Profile First</h2>
          <p style={{ color: "#78350f", fontSize: "16px", lineHeight: "1.6", marginBottom: "24px" }}>
            Before you can initiate a questionnaire, please complete your profile by providing your phone number and address details.
          </p>
          <button
            onClick={() => {
              // Switch to profile tab in parent component
              const event = new CustomEvent('switchToProfileTab');
              window.dispatchEvent(event);
              // Also try to navigate if we're in the profile page
              if (window.location.pathname.includes('/my-profile')) {
                // Already on profile page, just scroll to top
                window.scrollTo({ top: 0, behavior: 'smooth' });
              } else {
                navigate('/my-profile');
              }
            }}
            style={{
              padding: "12px 24px",
              background: "#d97706",
              color: "#ffffff",
              border: "none",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "600",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              transition: "all 0.2s ease"
            }}
            onMouseOver={(e) => e.target.style.background = "#b45309"}
            onMouseOut={(e) => e.target.style.background = "#d97706"}
          >
            <i className="fa-solid fa-user-edit"></i> Complete Profile
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="legal-wrapper">
      {/* Reference Number Display */}
      {referenceNumber && (
        <div className="reference-number-display">
          <i className="fa-solid fa-hashtag"></i>
          <span>Reference: <strong>{referenceNumber}</strong></span>
        </div>
      )}

      <h2>{TAB_CONTENT[activeTab].title}</h2>
      <p className="subtitle">{TAB_CONTENT[activeTab].subtitle}</p>

      {/* Tabs */}
      <div className="tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={activeTab === tab.key ? "active" : ""}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="questionnaire-layout">
        {/* Side Navigation */}
        <div className="side-navigation">
          <h3 className="nav-title">Sections</h3>
          <nav className="section-nav">
            {sections.map((section, index) => {
              const isCompleted = isSectionCompleted(index);
              const isActive = currentStep === index;
              return (
                <button
                  key={index}
                  className={`nav-item ${isActive ? "active" : ""} ${isCompleted ? "completed" : ""}`}
                  onClick={() => {
                    setCurrentStep(index);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  <span className="nav-item-number">{index + 1}</span>
                  <span className="nav-item-text">{section.section.replace(/^\d+\.\s*/, "")}</span>
                  {isCompleted && (
                    <i className="fa-solid fa-check-circle nav-checkmark"></i>
                  )}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Main Content */}
        <div className="questionnaire-content">
          {/* Progress Indicator */}
          <div className="step-progress">
            <div className="progress-bar">
              <div 
                className="progress-fill" 
                style={{ 
                  width: `${((currentStep + 1) / (sections.length || 1)) * 100}%` 
                }}
              ></div>
            </div>
            <p className="progress-text">
              Step {currentStep + 1} of {sections.length || 0}
            </p>
          </div>

          {/* Questions - Show only current step */}
          {sections[currentStep] && (
            <div className="question-section">
              <h3 className="section-title">
                {sections[currentStep].section}
              </h3>

              {sections[currentStep].questions.map((q, index) => (
                <div key={q.id} className="question-card">
                  <label>
                    {index + 1}. {q.label}
                    {q.required && <span style={{ color: "#dc2626", marginLeft: "4px" }}>*</span>}
                  </label>
                  {renderInput(q)}
                </div>
              ))}
            </div>
          )}

      {/* Step Navigation */}
      <div className="step-navigation">
        <button
          className="step-btn step-btn-prev"
          onClick={() => {
            if (currentStep > 0) {
              setCurrentStep(currentStep - 1);
              setFieldErrors(new Set());
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }}
          disabled={currentStep === 0}
        >
          <i className="fa-solid fa-arrow-left"></i> Previous
        </button>
        
        <div className="step-actions">
          {/* Save and Continue Button */}
          {!isCompleted && (
            <button
              className="step-btn step-btn-save-continue"
              onClick={() => handleSaveProgress()}
              disabled={saving || completing || loading}
            >
              {saving ? (
                <>
                  <i className="fa-solid fa-spinner fa-spin"></i> Saving...
                </>
              ) : (
                <>
                  <i className="fa-solid fa-floppy-disk"></i> Save & Continue Later
                </>
              )}
            </button>
          )}

          {/* Next/Complete Button */}
          <button
            className={`step-btn ${currentStep === sections.length - 1 ? "step-btn-save" : "step-btn-next"}`}
            onClick={() => {
              const totalSteps = sections.length;
              const isLastStep = currentStep === totalSteps - 1;
              
              if (isLastStep) {
                // On last step, validate all
                const allErrors = validateAnswers();
                if (allErrors.length === 0) {
                  // If already completed, allow updating
                  if (isCompleted) {
                    // Allow re-completion if they want to update
                    handleSave(true);
                  } else {
                    // Complete and submit
                    handleSave(true);
                  }
                } else {
                  // Scroll to first error
                  const firstErrorId = Array.from(fieldErrors)[0];
                  if (firstErrorId) {
                    setTimeout(() => {
                      const errorElement = document.querySelector(`[name="${firstErrorId}"], input[id="${firstErrorId}"], textarea[id="${firstErrorId}"]`);
                      if (errorElement) {
                        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
                        errorElement.focus();
                      }
                    }, 100);
                  }
                }
              } else {
                // On intermediate steps, validate current step before proceeding
                if (validateCurrentStep()) {
                  setCurrentStep(currentStep + 1);
                  setFieldErrors(new Set());
                  window.scrollTo({ top: 0, behavior: "smooth" });
                } else {
                  // Scroll to first error in current step
                  const firstErrorId = Array.from(fieldErrors)[0];
                  if (firstErrorId) {
                    setTimeout(() => {
                      const errorElement = document.querySelector(`[name="${firstErrorId}"], input[id="${firstErrorId}"], textarea[id="${firstErrorId}"]`);
                      if (errorElement) {
                        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
                        errorElement.focus();
                      }
                    }, 100);
                  }
                }
              }
            }}
            disabled={saving || completing || loading}
          >
            {currentStep < sections.length - 1 ? (
              <>
                Next <i className="fa-solid fa-arrow-right"></i>
              </>
            ) : completing ? (
              <>
                <i className="fa-solid fa-spinner fa-spin"></i> Completing...
              </>
            ) : isCompleted ? (
              <>
                <i className="fa-solid fa-check"></i> Update Answers
              </>
            ) : (
              <>
                <i className="fa-solid fa-check"></i> Complete & Submit
              </>
            )}
          </button>
        </div>
      </div>

      {/* Save Message Display */}
      {saveMessage.text && (
        <div
          style={{
            padding: "12px",
            marginTop: "20px",
            marginBottom: "0",
            borderRadius: "6px",
            backgroundColor: saveMessage.type === "success" ? "#d1fae5" : "#fee2e2",
            color: saveMessage.type === "success" ? "#065f46" : "#991b1b",
            textAlign: saveMessage.type === "error" ? "left" : "center",
            fontWeight: "500",
            whiteSpace: "pre-line",
            width: "100%",
          }}
        >
          {saveMessage.text}
        </div>
      )}
      
          {loading && (
            <p style={{ textAlign: "center", marginTop: "20px", color: "#666" }}>
              Loading saved answers...
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LegalQuestionnaire;  